import { ChoicesAnswer, MappedAnswer } from '../../components/context/SurveyPageContext';

const getChoicesAnswer = (
  mappedAnswers: Map<number, MappedAnswer>,
  questionId: number,
): ChoicesAnswer | undefined => {
  if (mappedAnswers.has(questionId)) {
    return mappedAnswers.get(questionId) as ChoicesAnswer;
  }
  return undefined;
};

export default getChoicesAnswer;
